import {
    instanceOfIHaveExecutionBounds,
    instanceOfIHaveExecutionDates, instanceOfIHaveProductGroups,
    instanceOfIHaveSecurity, instanceOfIHaveSourceCustomers,
    instanceOfIHaveTags
} from "./PA.Core/PA.Core.IF.Aspects";
import * as PAdbSchema from "./PA.Core/PAdbSchema";
import * as PAdbSchemaRows from "./PA.Core/PAdbSchemaRows";
import {PAdbContext} from "./PA.Core/PAdbContext";
import {PASessionContext} from "./PA.Core/PASessionContext";
import {PAusrContext} from "./PA.Core/PAusrContext";
import {ASync} from "./PA.Core/Basic/ASync";
import {TagTypes} from "./PA.Core/Basic/Constants";
import {DimensionType} from "./PA.Core/PA.Core.IF.Hierarchy";
import {ICellMetricNumberType, IDataLocation} from "./PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import {CollectionUtils} from "./PA.Core/Basic/Collections";
import {DateUtils, RRuleUtils} from "./PA.Core/Basic/Dates";
import {IdentityProvider} from "./PA.Core/Basic/Identity";
import {Index} from "./PA.Core/Basic/Index";
import {ProgressProvider} from "./PA.Core/Basic/Progress";
import {MessageType} from "./PA.Core/PA.Core.IF.Basic";
import {MessageProvider} from "./PA.Core/Basic/Messages";
import {NumberUtils} from "./PA.Core/Basic/Numbers";
import {RecordAggregate} from "./PA.Core/Basic/RecordAggregate";
import {SimpleRecord} from "./PA.Core/Basic/SimpleRecord";
import {TextUtils} from "./PA.Core/Basic/Text";
import {JSONUtils} from "./PA.Core/Basic/JSON";
import {UOMUtils} from "./PA.Core/Basic/UOM";
import {HierarchyUtils} from "./PA.Core/Basic/HierarchyUtils";
import {ESRecordResolver} from "./PA.Core/lib/ESRecordResolver";
import {PASearch} from "./PA.Core/PASearch";
import {PAEntity} from "./PA.Core/PAEntity";
import {LanguageTextService} from "./PA.Core/Language/LanguageTextService";
import {Domain_getDefaultOrFirstItem, Domain_getItems} from "./PA.Core/PAdbUtils";
import {EnterpriseUtils} from "./PA.Core/Basic/EnterpriseUtils";
import * as MessageUtils from "./PA.Core/Basic/MessageUtils";
import {HierarchyUsage} from "./PA.MD.Hierarchy/HierarchyUsage";


const MdlCore = {

    Core: {
        Interface: {
            instanceOfIHaveTags: instanceOfIHaveTags,
            instanceOfIHaveSecurity: instanceOfIHaveSecurity,
            instanceOfIHaveExecutionDates: instanceOfIHaveExecutionDates,
            instanceOfIHaveProductGroups: instanceOfIHaveProductGroups,
            instanceOfIHaveSourceCustomers: instanceOfIHaveSourceCustomers,
            instanceOfIHaveExecutionBounds: instanceOfIHaveExecutionBounds
        },
        Basic: {
            ASync: ASync,
            Constant: {
                TagTypes: TagTypes,
                DimensionType: DimensionType,
                IDataLocation: IDataLocation,

                ICellMetricNumberType: ICellMetricNumberType
            },
            CollectionUtils: CollectionUtils,
            DateUtils: DateUtils,
            RRuleUtils:RRuleUtils,
            IdentityProvider: IdentityProvider,
            Index: Index,
            ProgressProvider: ProgressProvider,
            MessageType: MessageType,
            MessageProvider: MessageProvider,
            NumberUtils: NumberUtils,
            RecordAggregate: RecordAggregate,
            SimpleRecord: SimpleRecord,
            TextUtils: TextUtils,
            JSONUtils: JSONUtils,
            UOMUtils: UOMUtils,
            HierarchyUtils: HierarchyUtils,
            HierarchyUsage: HierarchyUsage,
            DomainUtils: {
                Domain_getDefaultOrFirstItem,
                Domain_getItems
            },
            EnterpriseUtils: EnterpriseUtils,
            MessageUtils: MessageUtils
        },
        Utils: {
            ESRecordResolver: ESRecordResolver
        },
        SessionContext:PASessionContext,
        UsrContext: PAusrContext,
        DbContext: PAdbContext,
        DbSchema: PAdbSchema,
        DbSchemaRows: PAdbSchemaRows,
        Search: PASearch,
        Entity: PAEntity,
        LanguageTextService: LanguageTextService
    },

}

export {MdlCore}